module.exports = __webpack_public_path__ + "static/img/pic_5.f1743558.png";